export default __webpack_public_path__ + "static/media/Gripx_banner.37709347.png";